export const PHONE_NUMBER_OPTIONS = '(000) 000-0000';
export const ZIP_CODE_OPTIONS = '00000';
